(() => {
  const HERO_KEY = 'ppd-home-hero-v1';
  const heroNames = { editorial: 'editorial', image: 'image', collage: 'collage' };

  const readPreference = () => {
    try {
      const saved = localStorage.getItem(HERO_KEY);
      return heroNames[saved] ? saved : 'editorial';
    } catch {
      return 'editorial';
    }
  };

  const isHomePage = document.body.dataset.template === 'index' ||
    (window.location.pathname === '/' && !document.body.dataset.template);

  if (!isHomePage) return;

  let preference = readPreference();
  const heroSection = document.querySelector('.ppd-hero-section [data-ppd-hero-layout]');
  const header = document.querySelector('.ppd-site-header');
  const picker = document.querySelector('.ppd-hero-picker');

  const applyLayout = (layout) => {
    if (!heroSection) return;
    const baseClass = heroSection.className.split(' ').find(c => c.startsWith('ppd-hero--'));
    if (baseClass) {
      heroSection.classList.remove(baseClass);
    }
    heroSection.classList.add('ppd-hero--' + layout);
    heroSection.dataset.ppdHeroLayout = layout;
    document.body.dataset.ppdHomeHero = layout;

    if (picker) {
      picker.querySelectorAll('.ppd-hero-option').forEach(btn => {
        const isSelected = btn.dataset.ppdHeroChoice === layout;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', String(isSelected));
      });
    }
  };

  const initPicker = () => {
    if (!picker) return;
    picker.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ppd-hero-choice]');
      if (!button) return;
      preference = button.dataset.ppdHeroChoice;
      try { localStorage.setItem(HERO_KEY, preference); } catch {}
      applyLayout(preference);
    });
  };

  let scrollHandler = null;
  const applyScrollPastHero = () => {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    if (!header || !heroSection || preference !== 'image') {
      header?.classList.remove('is-past-hero');
      return;
    }
    scrollHandler = () => {
      const heroEnd = heroSection.offsetTop + heroSection.offsetHeight - header.offsetHeight;
      header.classList.toggle('is-past-hero', window.scrollY >= heroEnd);
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
    scrollHandler();
  };

  applyLayout(preference);
  initPicker();
  applyScrollPastHero();

  const observer = new MutationObserver(() => applyScrollPastHero());
  if (heroSection) {
    observer.observe(heroSection, { attributes: true, attributeFilter: ['data-ppd-hero-layout'] });
  }
})();
